import React, { useState, useEffect } from "react";
import { IonContent, IonPage, IonHeader, IonToolbar, IonTitle, IonGrid, IonRow, IonCol, IonText, IonButton } from "@ionic/react";

const fulldays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const generateCalendar = (year: number, month: number) => {
    const firstDay = new Date(year, month, 1).getDay();
    const totalDays = new Date(year, month + 1, 0).getDate();

    const calendarDays = Array(firstDay).fill(null);
    for (let i = 1; i <= totalDays; i++) {
        calendarDays.push(i);
    }
    return calendarDays;
};

const generateRandomQuestion = (year: number, month: number) => {
    const questionTypes = [
        "first_sunday", "last_saturday", "random_weekday", "count_days"
    ];
    const selectedType = questionTypes[Math.floor(Math.random() * questionTypes.length)];
    const calendarDays = generateCalendar(year, month); //console.log(calendarDays)
    let question = "", answer = 0;
    const randomDay = Math.floor(Math.random() * 7); console.log(randomDay);

    console.log(selectedType)

    switch (selectedType) {
        case "first_sunday": {
            answer = calendarDays.find((_, i) => i % 7 === 0 && calendarDays[i] != null); console.log(answer)
            question = "Which date is the first Sunday of the month?";
            break;
        }
        case "last_saturday": {
            const lastSaturday = calendarDays.reverse().find((_, i) => (calendarDays.length - 1 - i) % 7 === 6 && calendarDays[i] != null);
            answer = lastSaturday || 1;
            question = "Which date is the last Saturday of the month?";
            break;
        }
        case "random_weekday": {
            const weekdayIndex = Math.floor(Math.random() * 7); // Randomly pick a weekday (0 = Sunday, 6 = Saturday)
            const occurrence = Math.floor(Math.random() * 4) + 1; // Randomly pick 1st, 2nd, 3rd, or 4th occurrence
            let count = 0;
            let selectedDate = null;
        
            for (let i = 0; i < calendarDays.length; i++) {
                if (calendarDays[i] !== null && new Date(year, month, calendarDays[i]).getDay() === randomDay) {
                    count++;
                    if (count === occurrence) {
                        selectedDate = calendarDays[i];
                        break;
                    }
                }
            }
        
            answer = selectedDate || 1;
            const ordinal = ["first", "second", "third", "fourth"][occurrence - 1];
            question = `On which date does the ${ordinal} ${fulldays[randomDay]} fall?`;
            break;
        }
        
        case "count_days": {
            console.log(calendarDays)
            console.log(calendarDays.filter((_, i) => i % 7 === randomDay))
            question = `How many ${fulldays[randomDay]}s are there in this month?`;
            answer = calendarDays.filter((_, i) => i % 7 === randomDay && calendarDays[i] != null).length; console.log(randomDay, answer)
            break;
        }
        default:
            break;
    }

    const options = [answer];
    while (options.length < 4) {
        const randomOption = Math.floor(Math.random() * 31) + 1;
        if (!options.includes(randomOption)) options.push(randomOption);
    }
    return { question, options: options.sort(() => Math.random() - 0.5), answer };
};

interface QuestionData {
    question: string;
    options: number[];
    answer: number;
}

const CalendarPage: React.FC = () => {
    const today = new Date();
    const randomYear = Math.floor(Math.random() * (today.getFullYear() - 2000 + 1)) + 2000;
    const randomMonth = Math.floor(Math.random() * 12);

    const [year, setYear] = useState(randomYear);
    const [month, setMonth] = useState(randomMonth);
    const [calendarDays, setCalendarDays] = useState<number[]>([]);
    const [questionData, setQuestionData] = useState<QuestionData | null>();
    const [message, setMessage] = useState("");

    const handleOptionClick = (selectedOption: number) => {
        const element = document.getElementsByClassName("messageArea")[0];
        element.scrollIntoView({
            behavior: 'smooth', // Smooth scrolling animation
            block: 'center',    // Align the item in the center of the viewport
        });
        if (selectedOption === questionData?.answer) {
            setMessage("✅ Correct! Generating new question...");
            setTimeout(() => {
                const randomYear = Math.floor(Math.random() * (today.getFullYear() - 2000 + 1)) + 2000;
                const randomMonth = Math.floor(Math.random() * 12);

                setYear(randomYear);
                setMonth(randomMonth);
                setCalendarDays(generateCalendar(year, month));
                setQuestionData(generateRandomQuestion(year, month));
                setMessage("");
            }, 1000);
        } else {
            setMessage("❌ Wrong answer! Try again.");
        }
    };

    useEffect(() => {
        setCalendarDays(generateCalendar(year, month));
        setQuestionData(generateRandomQuestion(year, month));
        document.title = "Mamas Guidance - Class One - Mathematics - Calender - Look at Calender"; // Set page title
    }, [year, month]);

    //console.log(questionData)

    return (
        <div className="contentPart showCenter showCalender" style={{ padding: "0" }}>
            <h2 style={{ textAlign: "center" }}>
                {new Date(year, month).toLocaleString("default", { month: "long" })} {year}
            </h2>
            {/* Week Days Header */}
            <IonRow>
                {days.map((day, index) => (
                    <IonCol key={index} className="ion-text-center">
                        <IonText><strong>{day}</strong></IonText>
                    </IonCol>
                ))}
            </IonRow>
            {/* Calendar Days */}
            {Array.from({ length: Math.ceil(calendarDays.length / 7) }).map((_, rowIndex) => {
                const weekDays = calendarDays.slice(rowIndex * 7, rowIndex * 7 + 7);
                //console.log(weekDays)
                return (
                    <IonRow key={rowIndex}>
                        {weekDays.map((day, index) => (
                            <IonCol
                                key={index}
                                className="ion-text-center"
                                style={{ minHeight: "40px", border: "1px solid #ccc" }}>
                                {day !== null ? <IonText>{day}</IonText> : <IonText>&nbsp;</IonText>}
                            </IonCol>
                        ))}

                        {/* Add extra empty cells if last row has less than 7 days */}
                        {weekDays.length < 7 &&
                            Array.from({ length: 7 - weekDays.length }).map((_, i) => (
                                <IonCol key={`empty-${i}`} style={{ border: "1px solid #ccc", minHeight: "40px" }}>
                                    &nbsp;
                                </IonCol>
                            ))}
                    </IonRow>
                );
            })}

            <div style={{ textAlign: "center", marginTop: "20px", marginBottom: "20px" }}>
                <h3>{questionData?.question}</h3>
                <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap", marginTop: "20px" }}>
                    {questionData?.options.map((option, index) => (
                        <div className="purpleButton" key={index} onClick={() => handleOptionClick(option)} style={{ width: 'auto', padding: '10px', fontSize: '20px', minWidth: '60px' }}>
                            {option}
                        </div>
                    ))}
                </div>
                <p className="messageArea" style={{ fontWeight: "bold", marginTop: "10px", marginBottom: "40px" }}>{message}</p>
            </div>
        </div>
    );
};

export default CalendarPage;
